<template>
	<div>
		<b-input-group class="input-group-alternative input-group-merge">
			<DatePicker
				v-model="innerValue"
				@change="onChange"
				format="MM-DD-YYYY"
				value-type="format"
				input-class="form-control form-control-sm bg-white"
				:input-attr="{ id: 'report-date-from' }"
				range
			/>

			<template #append>
				<b-dropdown
					toggle-class="pl-2 pr-3"
					menu-class="overflow-hidden"
					class="border-left"
				>
					<template #button-content>
						<span class="mr-1">{{
							selectedField ? selectedField.text : "Date Filter"
						}}</span>
					</template>

					<div class="dropdown-wrapper">
						<div class="px-3 mt-1 mb-3">
							<b-form-input
								@input="handleDropdownSearch"
								size="sm"
								class="dropdown-wrapper__search"
								placeholder="Search"
							></b-form-input>
						</div>
						<div class="dropdown-wrapper__items">
							<template v-if="dropdownOptions.length">
								<b-dropdown-item
									v-for="dropdownOption in dropdownOptions"
									@click="selectedField = dropdownOption"
									:key="`field-${dropdownOption.value}`"
									>{{ dropdownOption.text }}</b-dropdown-item
								>
							</template>
							<small v-else class="d-block px-3"
								>No items found.</small
							>
						</div>
					</div>
				</b-dropdown>
			</template>
		</b-input-group>
	</div>
</template>

<script>
import { debounce } from "lodash-es";
import Fuse from "fuse.js";
import DatePicker from "vue2-datepicker";

export default {
	props: {
		value: Object,
		fields: Array,
	},
	components: {
		DatePicker,
	},
	data() {
		return {
			innerValue: null,
			selectedField: null,
			dropdownSearchValue: null,
		};
	},
	computed: {
		dropdownOptions() {
			let dropdownOptions = this.fields;

			if (this.dropdownSearchValue) {
				const fuse = new Fuse(dropdownOptions, {
					keys: ["text"],
					useExtendedSearch: true,
				});

				dropdownOptions = fuse
					.search(`'${this.dropdownSearchValue}`)
					.map((item) => item.item);
			}

			return dropdownOptions;
		},
	},
	methods: {
		onChange(value) {
			if (!this.selectedField) return;

			this.$emit("input", {
				key: this.selectedField.value,
				value: value,
			});
		},
		handleDropdownSearch: debounce(function (value) {
			this.dropdownSearchValue = value;
		}, 500),
	},
	watch: {
		value: {
			immediate: true,
			handler(newVal) {
				if (!newVal) return;

				this.innerValue = newVal.value;

				const idx = this.fields.findIndex(
					(item) => item.value === newVal.key
				);

				if (0 <= idx) this.selectedField = this.fields[idx];
			},
		},
		selectedField(newVal, oldVal) {
			if (oldVal || !this.innerValue) return;

			this.$emit("input", {
				key: newVal.value,
				value: this.innerValue,
			});
		},
	},
};
</script>

<style lang="scss">
.mx {
	&-datepicker {
		width: auto;
		min-width: 200px;

		@media screen and (max-width: 991px) {
			min-width: 1%;
			flex: 1 1 auto;
		}
	}

	&-input-wrapper {
		input {
			width: 100%;
			max-width: 100% !important;
			border-top-left-radius: 30px;
			border-bottom-left-radius: 30px;
		}
	}
}
</style>

<style lang="scss" scoped>
.dropdown-wrapper {
	&__items {
		max-height: 200px;
		overflow-y: auto;
		overflow-x: hidden;
	}

	&__search {
		border: 1px solid #dedede;
	}
}
</style>
